import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import Login from './components/Login';
import MenuBar from './components/MenuBar';
import StationList from './components/StationList';
import StationQuery from './components/StationQuery';
import SmartQuery from './components/SmaryQuery';
import FixRecord from './components/FixRecord';
import StationUploadFile from './components/StationUploadFile';
import Authentication from './Authentication';

const PrivateRoute = ({ children, ...rest }) => {

    return (
    <Route {...rest} render={() =>
        <>
            <MenuBar {...rest} />
            {Authentication() !== undefined ? (children) : (<Redirect to="/login" />)}
        </>
    } />
    )
};


function App() {
    return (
        <Router>
            <Switch>
                <PrivateRoute exact path="/">
                    <StationList />
                </PrivateRoute>
                <PrivateRoute path="/station">
                    <StationQuery />
                </PrivateRoute>
                <PrivateRoute path="/smart">
                    <SmartQuery /> 
                </PrivateRoute>
                <PrivateRoute path="/fixrecord">
                    <FixRecord /> 
                </PrivateRoute>
                <PrivateRoute path="/stationfile">
                    <StationUploadFile />                     
                </PrivateRoute>                
                <Route path="/login">
                    <Login />
                </Route>
            </Switch>
        </Router>
    );
}

export default App;
